import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconUploadSvg } from "./IconUploadSvg.mjs";
const IconUpload = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconUploadSvg, ...iconProps });
};
export {
  IconUpload
};
